import { useEffect, useRef, useState, KeyboardEvent } from 'react';
import { Link } from 'react-router';

interface ILinkItem {
	text: string;
	link?: string;
	target?: string;
	title?: string;
}

interface ILinkSelectBox {
	items: ILinkItem[];
}

const LinkSelectBox = ({ items }: ILinkSelectBox) => {
	const [isOpen, setIsOpen] = useState(false);
	const selectRef = useRef<HTMLDivElement | null>(null);

	const toggleSelect = () => setIsOpen(prev => !prev);

	const handleKeyUp = (e: KeyboardEvent<HTMLDivElement>) => {
		if (e.key === 'Enter') toggleSelect();
	};

	const handleClickOutside = (event: MouseEvent) => {
		if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	return (
		<div className="select-wrap family-site" tabIndex={0} onClick={toggleSelect} onKeyUp={handleKeyUp} ref={selectRef}>
			<span className="select-label">Family Site</span>
			<ul className={`select-list ${isOpen ? 'up' : ''}`} style={{ display: isOpen ? 'block' : 'none' }}>
				{items.map((item, index) => {
					return (
						<li key={`family-site-${index}`}>
							{item?.link ? (
								<Link to={item?.link} target={item.target} title={item.title}>
									{item.text}
								</Link>
							) : (
								item.text
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default LinkSelectBox;
